<div>

  <div class="columns">
    <div class="column is-2"></div>
    <div class="column has-text-centered">
      <div class="content" style="margin-left:0;margin-right:0;">

        <h1 class="title is-4 is-uppercase">Herzlichen Dank für Ihre Registrierung!</h1>
        <figure>
          <svg xmlns="http://www.w3.org/2000/svg" width="238.615" height="137.017" viewBox="0 0 238.615 137.017">
            <path id="Icon_ionic-md-done-all" data-name="Icon ionic-md-done-all"
                  d="M180.63,21.977,166.264,7.664,101.091,72.593,115.46,86.909ZM224.248,7.664,115.46,115.539,72.868,73.105,58.5,87.42l56.959,57.261,123.155-122.7ZM0,87.42l57.473,57.261,14.368-14.314L14.883,73.105Z"
                  transform="translate(0 -7.664)" fill="#336e99"/>
          </svg>
        </figure>

        <p>Ihre Anmeldung war erfolgreich!<br>
          <br>
          Melden Sie sich jetzt <a routerLink="/login">hier</a> an und geben Sie Ihre erste Bestellung auf.
          <br>
          <br>

      </div>
    </div>
    <div class="column is-4 has-text-left">

      <div class="content" style="margin-left:0;margin-right:0;">
        <p>
          <span class="is-bold">Fragen?</span><br>
          <br>
          DocEstate GmbH<br>
          Vilbeler Str. 29<br>
          60313 Frankfurt am Main<br>
          <br>
          Mail: anfragen@docestate.com<br>
        </p>
        <hr>

        <img class="custom-img" src="assets/images/logo/logo_black.svg" alt="DocEstate Logo">
      </div>
    </div>

  </div>
</div>
